(function (Drupal, $, once) {
  Drupal.behaviors.officeMap = {
    attach: function (context) {
      $(function () {
        once('office-map', '.paragraph-map__content').forEach(function (element) {
          $(".paragraph-map__tab").on("click", function () {
            var $this = $(this);
            var pos = $this.index();
            var items = $this
              .parent()
              .siblings(".paragraph-map__items")
              .children();
            $this.siblings().removeClass("is-active");
            $this.addClass("is-active");
            if (!items.eq(pos).is(":visible")) {
              items.removeClass("is-active").hide();
              items.eq(pos).show();
            }
          });
          $(".paragraph-map__item-header").on("click", function () {
            var $this = $(this);
            var items = $this.parent().siblings(".paragraph-map__item");
            $this.siblings(".paragraph-map__item-content").slideToggle(300);
            $this.toggleClass("is-active");
            items.children(".paragraph-map__item-content").slideUp(300);
          });
        });
      });
    },
  };
})(Drupal, jQuery, once);
